import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import React from 'react'

interface EventEditDeletePopupProps {
  currentValue: string
  allValue: string
  value: string
  disableAll?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export function EventEditDeletePopup({
  currentValue,
  allValue,
  value,
  disableAll,
  onChange,
}: EventEditDeletePopupProps): JSX.Element {
  return (
    <FormControl fullWidth={true} sx={{ bottom: '16px', marginTop: '16px' }}>
      <RadioGroup
        aria-labelledby="task-schedule-event-edit-delete-popup-radio-buttons-group"
        name="task-schedule-event-edit-delete-popup-radio-buttons-group"
        value={value}
        onChange={onChange}
      >
        <FormControlLabel value={currentValue} control={<Radio />} label={'This task'} />
        <FormControlLabel
          value={allValue}
          control={<Radio />}
          label={'All tasks in this schedule'}
          disabled={disableAll}
        />
      </RadioGroup>
    </FormControl>
  )
}
